import client from '../../client'

export interface Params {
  code?: string
  code2?: string
}

export interface Data {
  user: {
    name1: string
    name2: string
    kana1: string
    kana2: string
    sex: number | null
    birthdayYear: string
    birthdayMonth: string
    zip: string
    prefecture: number | null
    address1: string
    address2: string
    addressOther: string
    tel: string
    highSchPrefecture: number | null
    highSchNpp: number | null
    highSchName: string
    grade: number | null
    email: string
    hopeCourse: number | null
    hopeDepart1: number | null
    hopeDepart2: number | null
    hopeArea: number | null
  }
  cart: string[] /** 学校IDの配列 e.g. ['D100001'] */
}

export interface Response {
  confirm: {
    cart: {
      keitou?: { [key: number /** 系統ID e.g. 101 */]: string /** 系統の表示名 e.g. "文化・語学・人間" */ }
      photo: string
      prefecture: string /** 都道府県のID e.g. '1' */
      prefectureName: string
      ryokin: string
      schoolDataId: string | null
      schoolName: string
      schoolNo: string /** 学校ID e.g. 'D100001' */
      schoolType: number /** 学校タイプID e.g. 1 */
      schoolTypeName: string
      seikyuuCode: string
      shiryouType: number /** 資料請求タイプID e.g. 1 */
    }[]
    cartCount: number
    user: {
      address1: string
      address2: string
      addressOther: string
      birthday: string
      birthdayMonth: string
      birthdayYear: string
      email: string
      grade: string
      highSchName: string
      highSchNpp: string
      highSchPrefecture: string
      hopeArea: string
      hopeCourse: string
      hopeDepart1: string
      hopeDepart2: string
      kana1: string
      kana2: string
      name1: string
      name2: string
      prefecture: string
      sex: string
      tel: string
      zip: string
    }
  }
}

export async function confirm(data: Data, params: Params) {
  return client.post<Response>('confirm_request_appli_data', { form: data }, { params }).then(({ data }) => data)
}
